import { Component, Input, OnInit, Output } from '@angular/core';
import { interval, Observable, PartialObserver, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.less'],
    standalone: false
})
export class SliderComponent implements OnInit {

  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;

  constructor() { }

  @Input() media: any[] = [];

  @Input() delay: number = 10;

  @Input() loop: boolean = false;

  display: number = 0;

  time: number;
  ispause = new Subject();
  timer: Observable<number>;
  timerObserver: PartialObserver<number>;

  ngOnInit() {
    if(this.loop) {
      this.time = this.delay;
      this.timer = interval(1000).pipe(
        takeUntil(this.ispause)
      );
      this.timerObserver = {
        next: (_: number) => {
          if(this.time == 0) {
            this.ispause.next;
            this.plus();
            this.time = this.delay;
          }
          this.time--;
        }
      }
      this.timer.subscribe(this.timerObserver);
    }
  }

  minus() {
    this.display--;
    if(this.display < 0)
      this.display = this.media.length - 4;
  }
  plus() {
    this.display++;
    if(this.display > this.media.length - 4) {
      this.display = 0;
    }
  }

}
